import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionBullet from "../general/NtSectionBullet";
import { useMobile } from "../../../hooks/useMobile";
import NtText from "../../../components/NtText";

function NtDevopsDockerSection(props) {
  const isMobile = useMobile();

  const renderRow = (title, containerStyle) => {
    return (
      <View style={[{ flexDirection: "row" }, containerStyle]}>
        <View
          style={{
            backgroundColor: "white",
            height: 8,
            width: 8,
            borderRadius: 15,
            marginTop: 5,
            marginRight: 10,
          }}
        />
        <NtSectionDescription
          style={{ fontSize: 14, color: "white", fontWeight: "400" }}
        >
          {title}
        </NtSectionDescription>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{ flex: 1, flexDirection: isMobile ? "column-reverse" : "row" }}
      >
        {/* left */}
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
            WE CAN HELP PACKAGE YOUR SOFTWARE{" "}
            <NtText style={{ fontWeight: "900" }}>
              APPLICATIONS INTO CONTAINERS
            </NtText>
          </NtSectionTitle>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Modernize legacy applications into a microservices architecture.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Simplify the process of managing, monitoring and deploying your
            applications.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Improve application density, stability and uptime.
          </NtSectionBullet>
        </View>

        {/* right */}
        <View
          style={{
            flex: isMobile ? 0.5 : 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            style={[
              {
                width: 400,
                height: 400,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/devops-docker-logo.png")}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtDevopsDockerSection;
